module.exports = __webpack_public_path__ + "static/media/192.486ed01e.png";